'use client'

import { useDebugValue, useState } from 'react'

import { useEnhancedEffect } from './useEnhancedEffect'

export const useMediaQuery = (query: string): boolean => {
  const q = query.replace(/^@media( ?)/m, '')

  const supportsMatchMedia =
    typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined'
  const matchMedia = supportsMatchMedia ? window.matchMedia : null

  const [match, setMatch] = useState(() => {
    if (matchMedia) {
      return matchMedia(q).matches
    }
    return false
  })

  useEnhancedEffect(() => {
    if (!matchMedia) return

    const queryList = matchMedia(q)

    if (!queryList.addEventListener) return

    const updateMatch = () => setMatch(queryList.matches)

    queryList.addEventListener('change', updateMatch)

    return () => {
      queryList.removeEventListener('change', updateMatch)
    }
  }, [q, matchMedia])

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDebugValue({ query: q, match })
  }

  return match
}
